import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMineConversations = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 30,
	viewBox: "0 0 32 30",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M9.65659 26.9492C10.1385 26.9492 10.4759 26.7082 11.0421 26.1781L15.4036 22.2022L23.5361 22.2143C27.1265 22.2263 29.0541 20.2263 29.0541 16.6962V7.46731C29.0541 3.93718 27.1265 1.94922 23.5361 1.94922H8.01809C4.43974 1.94922 2.5 3.9251 2.5 7.46731V16.6962C2.5 20.2384 4.43974 22.2143 8.01809 22.2022H8.58432V25.7083C8.58432 26.4553 8.98189 26.9492 9.65659 26.9492Z",
			fill: "#E4EAEB"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.7771 12.1327C17.3669 12.1327 18.6558 10.8358 18.6558 9.23598C18.6558 7.63617 17.3669 6.33927 15.7771 6.33927C14.1872 6.33927 12.8983 7.63617 12.8983 9.23598C12.8983 10.8358 14.1872 12.1327 15.7771 12.1327Z",
			fill: "#416774"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M15.7771 12.7804C13.8556 12.7804 10.0197 13.7517 10.0197 15.6797V17.1293C10.0197 17.528 10.3436 17.8541 10.7394 17.8541H20.8149C21.2107 17.8541 21.5346 17.528 21.5346 17.1293V15.6797C21.5346 13.7517 17.6987 12.7804 15.7771 12.7804Z",
			fill: "#416774"
		})
	]
});
const ForwardRef = forwardRef(SvgMineConversations);
export { ForwardRef as ReactComponent };
